import { render, staticRenderFns } from "./AccountStatements.vue?vue&type=template&id=1aff67de&"
import script from "./AccountStatements.vue?vue&type=script&lang=js&"
export * from "./AccountStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aff67de')) {
      api.createRecord('1aff67de', component.options)
    } else {
      api.reload('1aff67de', component.options)
    }
    module.hot.accept("./AccountStatements.vue?vue&type=template&id=1aff67de&", function () {
      api.rerender('1aff67de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/AccountStatements.vue"
export default component.exports